export const environment = {
  production: true,
  externalEndpoints: {
    fullMatch: false,
    urls: ['mocky.io', 'assets'],
  },
};
